import React from 'react'

interface DiscountProps {
  children: React.ReactNode;
}

export function Discount ({ children }: DiscountProps) {
  return (
    <span className='body-bold text-violet-500'>
      <span className='sr-only'>Discount: </span>
      {children}
    </span>
  )
}

Discount.displayName = 'MarketplaceCard.Discount'
